import React from "react";

const Contact = () => (
    <div className="postcontent">
    <div className="postheader">Contact</div>
    <div className="text">
        <p>For professional inquiries or questions about my availability, please reach out via email:</p>
            <p><a href="mailto:AlyssaAlecci@gmail.com">AlyssaAlecci@gmail.com</a></p>
        
        </div>
    </div>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.jsx